<template>
    <div class="renderQueueMAnager">
      <div class="pageContent">
        <heading-wrap>
           <span slot="title">Render Queue Manager</span>
        </heading-wrap>
        <button @click="handleAuth">Authenticate</button>
        <button @click="getQueues">Get Queues</button>
        <hr/>
        <admin-batch
                v-for="(batch, index) in batches"
                :index="index"
                :name="batch.project"
                :batchId="batch.name"
                :key="batch.key"
                :html="batch.html"
                :psd="batch.psd"
                :batches="batches"
                :queues="batch.queues"
                :parentMoveUp="moveUp"
                :parentMoveDown="moveDown"
                :parentRemove="remove"
        />
      </div>
    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import AdminBatch from '@/components/AdminBatch/admin-batch'
import {ajaxMixin} from '@/mixins/ajaxMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'RenderQueueManager',
  mixins: [ajaxMixin, notificationMixin],
  components: {
    HeadingWrap,
    AdminBatch
  },
  data: () => ({
    batches: [
      {
        key: 1,
        project: 'A Project Title',
        name: 'Batch ID',
        queues: [
          {
            id: 1,
            name: 'Queue Name 1',
            progress: 10,
            status: 'processing',
            priority: 1,
            type: 'html'
          },
          {
            id: 2,
            name: 'Queue Name 2',
            progress: 30,
            status: 'processing',
            priority: 2,
            type: 'html'
          },
          {
            id: 3,
            name: 'Queue Name 3',
            progress: 5,
            status: 'processing',
            priority: 3,
            type: 'html'
          },
          {
            id: 4,
            name: 'Queue Name 4',
            progress: 75,
            status: 'processing',
            priority: 4,
            type: 'html'
          },
          {
            id: 5,
            name: 'Queue Name 5',
            progress: 96,
            status: 'processing',
            priority: 5,
            type: 'html'
          }
        ]
      },
      {
        key: 2,
        project: 'Another Project Title',
        name: 'Batch ID',
        queues: [
          {
            id: 1,
            name: 'Queue Name 1',
            progress: 7,
            status: 'processing',
            priority: 1,
            type: 'psd'
          },
          {
            id: 2,
            name: 'Queue Name 2',
            progress: 23,
            status: 'processing',
            priority: 2,
            type: 'psd'
          },
          {
            id: 3,
            name: 'Queue Name 3',
            progress: 45,
            status: 'processing',
            priority: 3,
            type: 'psd'
          },
          {
            id: 4,
            name: 'Queue Name 4',
            progress: 88,
            status: 'processing',
            priority: 4,
            type: 'psd'
          },
          {
            id: 5,
            name: 'Queue Name 5',
            progress: 76,
            status: 'processing',
            priority: 5,
            type: 'psd'
          }
        ]
      }
    ],
    queueJobs: []
  }),
  mounted () {
    this.queueJobs = this.queues
  },
  methods: {
    move (array, name, position, delta) {
      const index = this.getPositionFromString(array, name)
      const newIndex = index + delta
      if (newIndex < 0 || newIndex === array.length) return // already at the top or bottom.
      const indexes = [index, newIndex].sort() // sort the indexes
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]) // replace from lowest index, two elements, reverting the order
      array = array.map((item, index) => (item.position = index)) // update item positions
      // this.queueJobs = array
    },
    moveUp (array, element, position) {
      this.move(array, element, position, -1)
    },
    moveDown (array, element, position) {
      this.move(array, element, position, 1)
    },
    getPositionFromString (array, text) {
      return array.map((e) => e.name).indexOf(text)
    },
    remove (array, name) {
      const index = this.getPositionFromString(array, name)
      array.splice(index, 1)
      this.addNotification('info', `${name} has been removed.`)
      // this.queueJobs = array
    },
    /*
    auth () {
      console.log('Auth.')
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          console.log(xhr.responseText)
        }
      }
      xhr.open('POST', `http://otomo.local/api/auth`, true)
      // xhr.setRequestHeader('X-Authorization', token)

      const formData = new FormData()
      formData.append('username', 'bot.one@otomo.io')
      formData.append('password', 'Shitfaced16')
      xhr.send(formData)
    }, */
    handleAuth () {
      this.auth().then((response) => {
        const data = JSON.parse(response)
        this.getQueues(data.token)
      }).catch(error => {
        console.log('error', error)
      })
    },
    getQueues (token) {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', `http://otomo.local/api/queue`, true)
      xhr.onload = () => {
        if (xhr.status === 200) {
          console.log(xhr.responseText)
        } else {
          console.log(xhr.statusText)
        }
      }
      xhr.setRequestHeader('X-Authorization', token)
      xhr.send()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/render-queue-manager.vue